import { useQueryClient } from "@tanstack/react-query"

import { l2rApiAxiosInstance as axiosInstance } from "@l2r-front/l2r-query"
import { campaignQueryKeys } from "@l2r-front/l2r-shared-campaign"

import { useCampaignMutation } from "./useCampaignMutation"

type EditCampaignConfig = {
    errorSnackbarMessage?: string
    onSuccess?: (data: any) => void
    onError?: (error: any) => void
    successSnackbarMessage?: string
}

export function useCampaignEdit(
    campaignId: string,
    queryParameters = {},
    config = {
        errorSnackbarMessage: null,
        onSuccess: null,
        successSnackbarMessage: null,
    } as EditCampaignConfig,
) {
    const url = `campaigns/${campaignId}/`
    const queryClient = useQueryClient()

    return useCampaignMutation(
        url,
        axiosInstance.patch,
        {
            ...queryParameters,
        },
        {
            ...config,
            onSuccess: (data) => {
                config.onSuccess?.(data)
                const listQueryKey = campaignQueryKeys["list"]()
                queryClient.invalidateQueries(listQueryKey as any)
                const detailQueryKey = campaignQueryKeys["detail"](campaignId)
                queryClient.invalidateQueries(detailQueryKey as any)
            },
        },
    )
}
